import { Box, Spinner } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { useEffect, useState } from 'react';
import { COOKIES_KEY } from '../constants';
import { useAppDispatch } from '../redux/store';
import { setHasCookie } from '../redux/slices/authSlice';

export const Redirecting = () => {
  const { token } = useParams();

  // console.log(token);

  const navigate = useNavigate();
  const [cookiesSet, setCookiesSet] = useState(false);
  const dispatch = useAppDispatch();

  if (token !== undefined && !cookiesSet) {
    // set cookies
    const cookies = new Cookies();
    cookies.set(COOKIES_KEY, token, { path: '/' });
    setCookiesSet(true);
  }

  useEffect(() => {
    dispatch(setHasCookie(true));
    navigate('/', { replace: true });
  }, [cookiesSet]);

  return (
    <Box textAlign={'center'} mt={'45px'}>
      <Spinner />
    </Box>
  );
};
